<template lang="pug">
  v-data-table.elevation-1(:headers='headers' :items='facturas' sort-by='numFactura')
    template(v-slot:top)
     v-toolbar.head-toolbar-fdespacho(flat dense color='primary' dark)
        v-flex(class="d-flex flex-wrap justify-center")
          v-toolbar-title.justify-center(color='success') F. Cargadas
    template(v-slot:item.action='{ item }')
      v-icon(v-if='!read' color='error' @click='quitarFactura(item)') mdi-delete
    template(v-slot:no-data)
      h2.pa-2 No hay facturas cargadas
</template>

<script>
import Api from '@/services/methods'
export default {
  props: ['facturas', 'read' ],
  data: () => ({
    dialog: false,
    headers: [
      { text: 'Numero de factura', value:'numFactura'},
      {
        text: 'Fecha',
        align: 'left',
        sortable: false,
        value: 'fechaFact'
      },
      { text: 'Cliente', value: 'cliente', sortable: false },
      { text: 'Direccion', value: 'direccion', sortable: false },
      { text: 'Total', value: 'total', sortable: false },
      { text: 'Zona', value: 'zona', sortable: false },
      { text: 'Vendedor(usuario)', value: 'vendedor', sortable: false },
      { text: 'Acciones', value: 'action', align: 'right', sortable: false }
    ],
    productos: [],
    editedIndex: -1
    // editedItem: {
    //   idProducto: "",
    //   unidadMedida: "",
    //   costo: 0,
    //   precio: 0,
    //   cantidadSolicitada: 0,
    //   subTotal: 0,
    //   baseImponible: 0,
    //   idIva: "",
    //   gravado: 0,
    //   exento: 0,
    //   total: 0
    // },
    // defaultItem: {
    //   idProducto: "",
    //   unidadMedida: "",
    //   costo: 0,
    //   precio: 0,
    //   cantidadSolicitada: 0,
    //   subTotal: 0,
    //   baseImponible: 0,
    //   idIva: "",
    //   gravado: 0,
    //   exento: 0,
    //   total: 0
    // }
  }),

  methods: {
    quitarFactura (item) {
      this.$emit('quitar', item)
      // this.facturas.splice(this.facturas.indexOf(item), 1)
    }

    // close() {
    //   setTimeout(() => {
    //     this.editedItem = Object.assign({}, this.defaultItem);
    //     this.editedIndex = -1;
    //   }, 300);
    // },

  }
}
</script>
